/**
 * Remember Campaign focus:
 * - Mid-class leave / reopen → same class
 * - After complete → next incomplete class (never the finished one)
 */

const KEY = "pianoTutorLastCampaign";

export type LastCampaign = {
  stageId: number;
  classId: string;
  minutes: number;
};

export function readLastCampaign(): LastCampaign | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<LastCampaign>;
    if (
      typeof parsed.stageId !== "number" ||
      typeof parsed.classId !== "string" ||
      !parsed.classId ||
      typeof parsed.minutes !== "number"
    ) {
      return null;
    }
    return {
      stageId: parsed.stageId,
      classId: parsed.classId,
      minutes: parsed.minutes,
    };
  } catch {
    return null;
  }
}

export function saveLastCampaign(next: LastCampaign): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* private mode */
  }
}
